export enum RoutePaths {
  LOGIN = '/login',
  REGISTER = '/register',
  FORGOT_PASSWORD = '/forgot',
  DASHBOARD = '/dashboard',
  CHANGE_NAW = '/update',
  RESET_PASSWORD = '/reset',
}
